let sections = document.getElementsByClassName('privacy-policy__info__section');

if (sections.length !== 0) {

    let navUL = document.getElementById('privacySections');
    let navLI = navUL.getElementsByTagName('li');
    let windowHeight = window.innerHeight;
    let header = document.getElementById('header');

    const scroll = () => {
        let fromTop = window.pageYOffset;
        let curSection;
        let nextSection;

        for (let i = 0; i < sections.length; i++) {
            let divPos = sections[i].offsetTop;
            let id;

            console.log(fromTop);
            if (divPos - 1 < (fromTop + 150)) {
                curSection = sections[i];
                nextSection = sections[i + 1];
            } 

            id = curSection.getAttribute('id');

            if (id === '') {
                curSection = sections[i];
                id = curSection.getAttribute('id');
            }

            for (let i = 0; i < navLI.length; i++) {
                let a = navLI[i].getElementsByTagName('a');
                let ahref = a[0].getAttribute('href');

                if (ahref === '#' + id) {
                    navLI[i].classList.add('active');
                } else {
                    navLI[i].classList.remove('active');
                }
            }
        }
    };
    
    const windowLoadScroll = () => {

        let windowTop = window.pageYOffset;
        let windowBottom = windowTop + window.innerHeight;

        let group = document.getElementsByTagName('section');

        for (let i = 0; i < group.length; i++) {
            let elementTop = group[i].offsetTop;

            // if (windowBottom > (elementTop - group[i].offsetHeight * .5)) {
            //     group[i].classList.add('fixed-place');
            // }
        }
    };
    
    window.addEventListener('scroll', () => {
        scroll();
        windowLoadScroll();
    });

    window.addEventListener('load', () => {
        console.log('loaded');
        // sections[0].classList.add('fixed-place');
    });
}